/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MachineType
 */
export interface MachineType {
    /**
     * 
     * @type {string}
     * @memberof MachineType
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MachineType
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof MachineType
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof MachineType
     */
    description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MachineType
     */
    toolIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MachineType
     */
    safetyWarningIds?: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof MachineType
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof MachineType
     */
    updatedAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof MachineType
     */
    active?: boolean;
}

/**
 * Check if a given object implements the MachineType interface.
 */
export function instanceOfMachineType(value: object): value is MachineType {
    return true;
}

export function MachineTypeFromJSON(json: any): MachineType {
    return MachineTypeFromJSONTyped(json, false);
}

export function MachineTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MachineType {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'toolIds': json['toolIds'] == null ? undefined : json['toolIds'],
        'safetyWarningIds': json['safetyWarningIds'] == null ? undefined : json['safetyWarningIds'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function MachineTypeToJSON(value?: MachineType | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'type': value['type'],
        'name': value['name'],
        'description': value['description'],
        'toolIds': value['toolIds'],
        'safetyWarningIds': value['safetyWarningIds'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'active': value['active'],
    };
}

